import styled from 'styled-components';
import colors from '../common/theme/colors';

const KitCloseButton = styled.button`
  && {
    background: 0;
    border: 0;
    color: ${colors.gray_30};
    padding: 0;
    position: relative;
    height: 1.25rem;
    width: 1.25rem;
    transition: color 0.2s;
    font-weight: 400;
    cursor: pointer;

    &:after {
      width: 1.25rem;
      height: 1.25rem;
      line-height: 1.25rem;
      top: 50%;
      transform-origin: center;
      transform: translateY(-50%);
      right: 0;
      content: '×';
      font-size: 32px;
      position: absolute;
    }

    &:focus {
      color: ${({ theme }) => theme.button.primary.normal.bg};
      outline-offset: 2px;
      outline: 2px solid ${({ theme }) => theme.focus};
    }

    &:hover {
      color: ${({ theme }) => theme.button.primary.normal.bg};
    }
  }
`;

export default KitCloseButton;
